import { render, staticRenderFns } from "./FoodList.vue?vue&type=template&id=34b53120&scoped=true"
import script from "./FoodList.vue?vue&type=script&lang=js"
export * from "./FoodList.vue?vue&type=script&lang=js"
import style0 from "./FoodList.vue?vue&type=style&index=0&id=34b53120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b53120",
  null
  
)

export default component.exports